import React, { useEffect, useState } from "react";
import Main from "../pages/Main";
import AppBreadcrumbs from "./ui/AppBreadcrumbs";
import { fetchTeamMembers } from "../api/teamsMemeberApi";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { FinalMerchantActive } from "../api/userAuth";

import { useNotify } from "../context/NotifyContext";

const Inactive = () => {
  const { userInfo } = useSelector((state) => state?.auth);
  const [searchParams, setSearchParams] = useSearchParams();
  const rawStatus = searchParams.get("status");
  const status = rawStatus?.trim().toLowerCase();
  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [teams, setInactiveTeams] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalbyall, setTotalbyAll] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [counts, setCounts] = useState({ total: 0, active: 0, inactive: 0 });
  const [selectedType, setSelectedType] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { notify } = useNotify(); // ✅ use notify

  const fetch_teams = async () => {
    const params = { page, limit, search: searchQuery, status: status };
    try {
      const result = await fetchTeamMembers(params);
      if (result?.success) {
        const response = result?.data;
        setInactiveTeams(response?.user);
        setTotalPages(response?.pagination?.totalPages || 1);
        setPage(response?.pagination?.page || 1);
        setLimit(response?.pagination?.limit || 10);
        setTotalbyAll(response?.pagination?.totalUsers || 0);
        setCounts(response.counts || { total: 0, active: 0, inactive: 0 });
      } else {
        notify(result?.message || "Failed to fetch teams", "error"); // ✅ notify
      }
    } catch (error) {
      notify("Server error while fetching teams", "error"); // ✅ notify
    }
  };

  const validStatus = ["active", "inactive"];

  useEffect(() => {
    if (status && !validStatus.includes(status)) {
      notify("Invalid status in URL", "error"); // ✅ notify
      navigate("/teams");
    }
    fetch_teams();
  }, [status]);

  useEffect(() => {
    fetch_teams();
  }, [page, limit, searchQuery]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetch_teams();
    }, 2000);
    return () => clearTimeout(delayDebounce);
  }, [searchQuery]);

  const handleView = (row) => {
    setSelectedRow(row);
    setSelectedType("view");
    setOpenModal(true);
  };

  const toggleStatus = (row, data) => {
    if (data === "kyc") {
      navigate(`/merchant/${row?.userName}`);
    }
    setSelectedType(data);
    setSelectedRow(row);
    setOpenModal(true);
  };

  const updateStatusInURL = (value) => {
    if (!value) {
      setSearchParams({});
    } else {
      setSearchParams({ status: value });
    }
  };

  const roleStyles = {
    distributor: "bg-[#EDFAFA] ",
    super_distributor: "bg-[#EDF7FA] ",
    retailer: "bg-[#EFFAED] ",
  };

  const getRoleClass = (role) =>
    roleStyles[role?.toLowerCase()] || "bg-gray-100 text-gray-500";

  const createFinalUser = async () => {
    if (!selectedRow?.planId || !selectedRow?.userName) {
      return notify("Plan is not active", "error"); // ✅ notify
    }
    setLoading(true);
    try {
      const payload = {
        planId: selectedRow?.planId?._id,
        userName: selectedRow?.userName,
        active: true,
      };
      const res = await FinalMerchantActive(selectedRow?.userName, payload);
      if (res.success) {
        notify(res?.message || "User Created & Activated!", "success"); // ✅ notify
        navigate(`/inactive?status=${status}`);
        setOpenModal(false);
        fetch_teams();
      }
    } catch (err) {
      notify(
        err?.response?.data?.message || "User Creation Failed",
        "error"
      ); // ✅ notify
    } finally {
      setLoading(false);
    }
  };





return ( 
<Main showRightPanel={false}> 
<div className="mt-4 font-[Poppins]">
    <AppBreadcrumbs
      items={[
        { label: "Dashboard", to: "/" },
        { label: `${status} Members` },
      ]}
    />
    <div className="bg-white shadow-sm border rounded-lg p-2 mb-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mt-2">
      <div className="flex items-center gap-3">
        <img
         src={`${userInfo?.logo}`}
          alt="profile"
          className="h-12 w-12 object-cover rounded-md"
        />
        <div className="flex flex-col sm:flex-row sm:items-center sm:gap-2">
          <p className="text-sm sm:text-base font-semibold">
            {userInfo?.name || "Anddy's Makeover"}
          </p>
          <span className="hidden sm:block">|</span>
          <p className="text-xs sm:text-sm font-semibold">
            ID: {userInfo?.userName ||"12542697"}
          </p>
        </div>
      </div>
    </div>
    <div className="bg-white p-4 rounded-lg shadow-md border mt-4">
<div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 w-full">
<div className="flex flex-wrap gap-2 w-full sm:w-auto">
  {}
  <button
    onClick={() => updateStatusInURL(null)}
    className={`px-3 py-2 rounded-md text-xs md:text-sm font-semibold shadow-sm
      ${!status
        ? "bg-[#02026E] text-white"
        : "bg-[#02026E26] text-[#02026E]"
      }`}
  >
    Total Members: {counts.total}
  </button>
  {}
  <button
    onClick={() => updateStatusInURL("active")}
    className={`px-3 py-2 rounded-md text-xs md:text-sm font-semibold shadow-sm
      ${status === "active"
        ? "bg-[#1FAE39] text-white"
        : "bg-[#1FAE3926] text-[#1FAE39]"
      }`}
  >
    Active Members: {counts.active}
  </button>
  {}
  <button
    onClick={() => updateStatusInURL("inactive")}
    className={`px-3 py-2 rounded-md text-xs md:text-sm font-semibold shadow-sm
      ${status === "inactive"
        ? "bg-[#EF3463] text-white"
        : "bg-[#EF346326] text-[#EF3463]"
      }`}
  >
    Inactive Members: {counts.inactive}
  </button>
</div>
<div className="w-1/2 ml-auto sm:w-auto flex justify-end">
  <input
    type="text"
    placeholder="Search"
    className="border border-gray-300 rounded-md px-3 py-1 text-sm 
               w-full sm:w-60 focus:ring-2 focus:ring-[#006FA9]"
  />
</div>
</div>
      <div className="overflow-x-auto mt-4">
        <table className="w-full bg-white rounded-lg border">
          <thead className="bg-[#006FA9] text-white text-xs sm:text-sm whitespace-nowrap">
            <tr>
              <th className="px-2 py-2 text-left">SNo.</th>
              <th className="px-2 py-2 text-left">Merchant</th>
              <th className="px-2 py-2 text-left">Role</th>
              <th className="px-2 py-2 text-left">Registration</th>
              <th className="px-2 py-2 text-left">KYC</th>
              <th className="px-2 py-2 text-left">Plan Assign</th>
              <th className="px-2 py-2 text-center">Action</th>
            </tr>
          </thead>
          <tbody className="text-xs sm:text-sm">
{teams?.length === 0 ? (
              <tr>
                <td colSpan="6" className="py-2 px-3 text-center">
                  No {status} User  Found
                </td>
              </tr>
            ) :
           ( teams?.map((row, i) => (
              <tr key={i} className="border-b">
                <td className="px-2 py-2">{(page-1)*limit + i + 1}</td>
   <td className="px-2 py-2 text-start">
  <div className="flex flex-col justify-center gap-1 ">
    <span className="font-medium whitespace-nowrap">{row?.name}</span>
    <span className="text-xs bg-[#E3F4FC] px-2 py-1 w-fit rounded-sm">
      {row.userName}
    </span>
  </div>
</td>
<td className="px-3 py-2 uppercase whitespace-nowrap">
  <span
    className={`text-xs font-semibold px-3 py-2 rounded-sm whitespace-nowrap
      ${getRoleClass(row?.role)}
    `}
  >
    {`# ${row?.role?.replace("_", " ")}`}
  </span>
</td>
                <td className="px-2 py-2">
                  <button
                    onClick={() => toggleStatus(row, "registration")}
                    className="px-3 py-1 rounded-md font-semibold text-[10px] sm:text-xs 
                        bg-[#1FAE3926] text-[#1FAE39] "
                  >
                    Completed
                  </button>
                </td>
                <td className="px-2 py-2">
               <button
  onClick={() => {
    if (!row.isKyc) toggleStatus(row, "kyc");
  }}
  disabled={row.isKyc}
  className={`px-3 py-1 rounded-md font-semibold text-[10px] sm:text-xs transition
    ${
      row.isKyc
        ? "bg-[#1FAE3926] text-[#1FAE39] cursor-not-allowed"
        : "bg-[#EF346326] text-[#EF3463] hover:bg-[#EF346340] cursor-pointer"
    }
  `}
>
  {row.isKyc ? "Completed" : "Pending"}
</button>
                </td>
                <td className="px-2 py-2">
                  <button
                    onClick={() => toggleStatus(row, "plan")}
                    disabled={row?.isActive}
                    className={`px-3 py-1 rounded-md font-semibold text-[10px] sm:text-xs ${
                      row.isActive 
                        ? "bg-[#1FAE3926] text-[#1FAE39]"
                        : "bg-[#EF346326] text-[#EF3463]"
                    }`}
                  >
                    {row.isActive  ? "Completed" : "Pending"}
                  </button>
                </td>
                <td className="px-2 py-2">
                  <div className="flex gap-1 sm:gap-2 justify-center">
                    <button
                      className="px-2 sm:px-3 py-1 rounded-md text-[10px] sm:text-xs font-semibold bg-[#02026E26] text-[#02026E]"
                      onClick={() => handleView(row)}
                    >
                      View
                    </button>
                    {}
                    {}
                  </div>
                </td>
              </tr>
            )))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
{openModal && selectedRow  && (selectedType === "kyc" || selectedType === "view") && (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center p-4 z-50">
      <div className="bg-white p-5 rounded-lg w-full max-w-xs sm:max-w-sm shadow-lg">
        <h2 className="text-lg font-semibold mb-4">Merchant Details</h2>
        <div className="space-y-2 text-sm">
          <p><strong>Name:</strong> {selectedRow.name}</p>
          <p><strong>Role:</strong> {selectedRow.role}</p>
          <p><strong>Email:</strong> {selectedRow.email}</p>
          <p><strong>Mobile:</strong> {selectedRow.phone}</p>
          <p><strong>Active Plan:</strong> {selectedRow.planId?.code}</p>
        </div>
        <div className="flex justify-end mt-4">
          <button
            className="px-4 py-1 bg-[#EF346326] text-[#EF3463] rounded-md text-sm"
            onClick={() => setOpenModal(false)}>
            Close
          </button>
        </div>
      </div>
    </div>
  )}
    {selectedType ==="plan" && openModal && selectedRow && (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center p-4 z-50">
      <div className="bg-white p-5 rounded-lg w-full max-w-xs sm:max-w-sm shadow-lg">
        <h2 className="text-lg font-semibold mb-4">Merchant Plan</h2>
        <div className="space-y-2 text-sm">
          <p><strong>Name:</strong> {selectedRow.name}</p>
          <p><strong>Role:</strong> {selectedRow.role}</p>
          <p><strong>PlanCode:</strong> {selectedRow.planId?.code}</p>
          <p><strong>Parent:</strong> {selectedRow.parentId?.userName}</p>
        </div>
        <div className="flex justify-between mt-4">
          <button
            className="px-4 py-1 bg-[#7ffc98b5] text-[#EF3463] rounded-md text-sm"
            onClick={createFinalUser}>
            Active
          </button>
             <button
            className="px-4 py-1 bg-[#EF346326] text-[#EF3463] rounded-md text-sm"
            onClick={() => setOpenModal(false)}>
            Close
          </button>
        </div>
      </div>
    </div>
  )}
</Main>
);
};
export default Inactive;